const routeType = {
  app: 'app',
  blog: 'blog',
  extern: 'extern',
};
export default routeType;
